document.addEventListener('DOMContentLoaded', function() {
  const logosContainer = document.querySelector('.ucc__mobile-brands-inner-logos');
  const logosInner = document.querySelector('.ucc__mobile-brands-inner-logos-inner');
  const logos = document.querySelectorAll('.ucc__mobile-brands-inner-logos-inner a');
  
  for (let i = 0; i < 5; i++) {
    logos.forEach(logo => {
      const clone = logo.cloneNode(true);
      logosInner.appendChild(clone);
    });
  }

  let scrollPosition = 0;
  let isStopped = false;
  let animationFrame;
  let lastTime = 0;
  const scrollSpeed = 30;

  function scrollLogos(timestamp) {
    if (!lastTime) lastTime = timestamp;
    const deltaTime = timestamp - lastTime;
    lastTime = timestamp;

    if (!isStopped) {
      scrollPosition += (scrollSpeed * deltaTime) / 1000;
      
      const totalWidth = logosInner.offsetWidth;
      const logoWidth = logos[0].offsetWidth + 27;
      const totalLogos = logos.length;
      
      if (scrollPosition >= totalWidth - logoWidth) {
        scrollPosition = 0;
      }
      
      logosInner.style.transform = `translateX(${-scrollPosition}px)`;
    }
    
    animationFrame = requestAnimationFrame(scrollLogos);
  }

  function stopScroll() {
    isStopped = true;
    cancelAnimationFrame(animationFrame);
    
    const currentPosition = scrollPosition;
    const logoWidth = logos[0].offsetWidth + 27;
    const currentLogoIndex = Math.floor(currentPosition / logoWidth) % logos.length;
    
    const allLogos = document.querySelectorAll('.ucc__mobile-brands-inner-logos-inner a');
    const originalLogos = Array.from(logos);
    const logosToKeep = new Set();
    originalLogos.forEach(logo => logosToKeep.add(logo));
    
    allLogos.forEach(logo => {
      if (!logosToKeep.has(logo)) {
        logo.remove();
      }
    });

    logosContainer.scrollLeft = currentPosition % (logoWidth * logos.length);
    logosInner.style.transform = 'none';

    logosContainer.removeEventListener('touchstart', stopScroll);
    logosContainer.removeEventListener('mousedown', stopScroll);
  }

  logosContainer.addEventListener('touchstart', stopScroll, { once: true });
  logosContainer.addEventListener('mousedown', stopScroll, { once: true });

  scrollLogos(0);
});
